import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/app/[slug]/translations/page.tsx");
